/**
 * The wire shape `Rws.AiInsights.Host.Forwarding.TrustedProxyEndpoints` returns: the proxies whose forwarded client address and scheme the
 * portal believes. Gated on `settings.write`. A change takes effect on this node at once and on the others within a minute.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** The trusted proxies, as a comma-separated list. */
export interface TrustedProxies {
  /** IP addresses and CIDR networks, comma-separated. */
  addresses: string;
  /** When the list was last saved, or `null` while the configured fallback applies. */
  updatedAt: string | null;
  /** `true` when an administrator saved the list; `false` when the configured fallback applies. */
  saved: boolean;
}

const trustedProxiesPath = "/api/entitlement/settings/trusted-proxies";

/** Calls `GET /api/entitlement/settings/trusted-proxies`. */
export async function fetchTrustedProxies(): Promise<AdminResult<TrustedProxies>> {
  return adminRequest<TrustedProxies>(trustedProxiesPath, { method: "GET" }, "trusted proxies");
}

/** Calls `PUT /api/entitlement/settings/trusted-proxies`. */
export async function updateTrustedProxies(addresses: string): Promise<AdminResult<TrustedProxies>> {
  return adminRequest<TrustedProxies>(trustedProxiesPath, { method: "PUT", body: JSON.stringify({ addresses }) }, "trusted proxies update");
}
